<template>
  <div class="mds-search-field__container search-field__container">
    <div class="mds-search-field search-field" role="search">
      <input
        type="text"
        aria-label="Search"
        class="mds-search-field__input search-field__input"
        :placeholder="placeholder"
        :class="{ empty: !hasText }"
        :disabled="disabled"
        :value="text"
        @keyup="onKeyUp"
      />
      <svg
        class="mds-icon mds-search-field__search-icon search-field__search-icon"
        aria-hidden="true"
      >
        <use xlink:href="static/mds/icons/mds.svg#search--s"></use>
      </svg>
      <button
        type="button"
        @click="clearText"
        class="mds-search-field__clear-button mds-button mds-button--small mds-button--icon-only"
        v-if="hasText"
      >
        <svg class="mds-icon mds-button__icon search-field__clear-icon" aria-hidden="true">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="static/mds/icons/mds.svg#remove--s"
          ></use>
        </svg>
      </button>
      <span class="mds-search-field__input-focus-outline"></span>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus';

export default {
  name: 'search-field',
  props: {
    placeholder: {
      type: String,
      default: 'Search by fund name, ticker, SecID',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  computed: {
    hasText() {
      return this.text && this.text.length > 0;
    },
  },
  created() {
    EventBus.$on('search-clear', () => {
      this.clearText();
    });
  },
  methods: {
    onKeyUp(event) {
      this.text = event.target.value;
      this.$emit('onChange', this.text);
    },
    clearText() {
      this.text = '';
      this.$emit('onChange', this.text);
    },
  },
  watch: {
    clear(newValue) {
      if (newValue) {
        this.clearText();
      }
    },
  },
};
</script>

<style lang="scss">
@mixin placeholder {
  &::-webkit-input-placeholder {
    @content;
  }
  &:-moz-input-placeholder {
    @content;
  }
  &::-moz-input-placeholder {
    @content;
  }
  &:-moz-placeholder {
    @content;
  }
  &::-moz-placeholder {
    @content;
  }
  &:-ms-input-placeholder {
    @content;
  }
}
.search-field {
  &__container {
    position: absolute;
    right: $mds-space-2-x;
    top: $mds-space-2-and-a-half-x;
    width: 280px;
  }
  &__input.mds-search-field__input {
    color: $mds-color-white;
    border-color: $mds-color-white;
    @include placeholder {
      color: $mds-color-white;
    }
  }
  .mds-search-field__input.empty {
    padding-right: $mds-space-inset-three-quarter-x;
  }
  .mds-search-field__input:focus:enabled + svg {
    fill: $mds-color-neutral-80;
  }
  .mds-search-field__input:hover:enabled + svg {
    fill: $mds-color-neutral-80;
  }
  &__search-icon.mds-icon,
  &__clear-icon.mds-icon.mds-button__icon {
    fill: $mds-color-white;
  }
}
</style>
